import { useCallback, useState } from 'react'
import type { MapView, RegionSlug } from '@/types/map'

function getHistory(v: MapView): MapView[] {
  return v.kind === 'globe' ? [] : v.history
}

export function useMapView() {
  const [view, setView] = useState<MapView>({ kind: 'globe' })

  const drillToRegion = useCallback((slug: RegionSlug) => {
    setView((prev) => ({ kind: 'region', slug, history: [...getHistory(prev), prev] }))
  }, [])

  const drillToCountry = useCallback((iso2: string) => {
    setView((prev) => ({ kind: 'country', iso2, history: [...getHistory(prev), prev] }))
  }, [])

  const drillToSite = useCallback((targetId: string) => {
    setView((prev) => ({ kind: 'site', targetId, history: [...getHistory(prev), prev] }))
  }, [])

  const back = useCallback(() => {
    setView((prev) => {
      const hist = getHistory(prev)
      if (hist.length === 0) return { kind: 'globe' }
      return hist[hist.length - 1]
    })
  }, [])

  const reset = useCallback(() => setView({ kind: 'globe' }), [])

  return { view, drillToRegion, drillToCountry, drillToSite, back, reset }
}
